import { Pressable, View } from "react-native";
import Animated, { FadeInDown } from "react-native-reanimated";
import { Snowflake } from "lucide-react-native";
import {
  pressLabel,
  usePressCapture,
} from "@src/packages/analytics/usePressCapture";

type Props = {
  label: string;
  index: number;
  Icon: typeof Snowflake;
  onPress?: () => void;
};

export default function AnswerChip({ label, index, Icon, onPress }: Props) {
  const capturePress = usePressCapture("AnswerChip");
  const chip = (
    <Animated.View
      entering={FadeInDown.springify()
        .damping(14)
        .stiffness(150)
        .delay(index * 60)}
      style={{
        width: 30,
        height: 30,
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 999,
        backgroundColor: "rgba(255, 255, 255, 0.10)",
        borderWidth: 1,
        borderColor: "rgba(255, 255, 255, 0.18)",
      }}
    >
      <Icon size={15} color="rgba(255, 255, 255, 0.82)" strokeWidth={1.6} />
    </Animated.View>
  );

  if (onPress) {
    return (
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={label}
        hitSlop={6}
        onPress={() => {
          capturePress(pressLabel(label), "onboarding_answer_chip");
          onPress();
        }}
      >
        {chip}
      </Pressable>
    );
  }
  return (
    <View accessible accessibilityLabel={label} accessibilityRole="image">
      {chip}
    </View>
  );
}
